// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {PRODUCT_NAME} from '@app/features/app/config/I18nDisplayConstants';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface InvitesDisabledModalProps {
	isRaidDetected?: boolean;
}
export const InvitesDisabledModal = observer(({isRaidDetected = false}: InvitesDisabledModalProps) => {
	const {t} = useLingui();
	return (
		<ConfirmModal
			title={t`Invites Paused`}
			description={
				isRaidDetected
					? t`${PRODUCT_NAME} detected a potential raid in this community, so invites are paused and new users can't join right now.`
					: t`The admins of the community have paused invites, so you can't join at this time.`
			}
			primaryText={t`Understood`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
